import FlexPane from './_flex-pane.js'
import Text from './_text.js'
import Image from './_image.js'
import SelectionButton from './_selection-button.js'

export default {
  name: 'PriceBoostItem',
  values: {
    showMarketLabel: true,
    container: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          padding: '8px 0',
        },
      },
    },
    labelContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '2px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    marketLabel: {
      configSet: Text,
      configValues: {
        style: {
          wordBreak: 'break-word',
        },
      },
    },
    selectionLabel: {
      configSet: Text,
      configValues: {
        style: {
          wordBreak: 'break-word',
        },
      },
    },
    priceInformationContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          justifyContent: 'flex-end',
          alignSelf: 'flex-end',
          flexGrow: 0,
          flexShrink: 0,
          flexBasis: '136px',
        },
      },
    },
    wasContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          justifyContent: 'space-evenly',
          alignItems: 'center',
          minWidth: '40px',
        },
      },
    },
    wasTitle: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    wasPrice: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
        style: {
          textDecoration: 'line-through',
        },
      },
    },
    indicationIcon: {
      configSet: Image,
      configValues: {
        src: 'double-arrow-right',
        style: {
          minWidth: '12px',
        },
      },
    },
    selectionButton: {
      configSet: SelectionButton,
      configValues: {
        view: {
          layoutDirection: 'vertical',
          nameDisplay: 'hide',
          _mobile_nameDisplay: 'hide',
          handicapDisplay: false,
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
